(function () {
    document.addEventListener('click', async function (event) {
      const btn = event.target.closest('#load-more-btn');
      if (!btn || btn.dataset.loading === 'true') return;

      const nextUrl = btn.dataset.nextUrl;
      const gridId = btn.dataset.gridId;
      const grid = document.getElementById(gridId);
      const container = document.getElementById('load-more-container');

      if (!nextUrl || !grid) return;

      // Show loading state
      btn.dataset.loading = 'true';
      btn.querySelector('.load-more-btn__text').style.display = 'none';
      btn.querySelector('.load-more-btn__loading').style.display = 'inline';

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Network response was not ok');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Grab new product cards from the fetched page's grid
        const newGrid = doc.getElementById(gridId);
        if (newGrid) {
          // Append each child node from the new grid into the existing grid
          Array.from(newGrid.children).forEach((child) => {
            grid.appendChild(document.adoptNode(child));
          });
        }

        // Update the "Load More" button to the next page URL (or remove it if no more pages)
        const newBtn = doc.getElementById('load-more-btn');
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.dataset.loading = 'false';
          btn.querySelector('.load-more-btn__text').style.display = 'inline';
          btn.querySelector('.load-more-btn__loading').style.display = 'none';
        } else {
          // No more pages — remove the button entirely
          container.remove();
        }

      } catch (error) {
        console.error('Load more failed:', error);
        // Restore button on error
        btn.dataset.loading = 'false';
        btn.querySelector('.load-more-btn__text').style.display = 'inline';
        btn.querySelector('.load-more-btn__loading').style.display = 'none';
      }
    });
  })();